export function Breadcrumbs({ breadcrumbs }) {
  const listItems = breadcrumbs.map((item) => {
    if (item.link.length > 0) {
      return <li key={item.title}><a href={item.link}> {item.title} </a></li>
    }

    return <li key={item.title}>{item.title}</li>
  })
  return (
    <ul className='mtt-breadcrumbs'>
      {listItems}
    </ul>
  )
}
